var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaregiver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2021_5244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.66823 30.3819C8.034 30.3819 6.70911 31.7068 6.70911 33.3409C6.70911 34.9753 8.034 36.3001 9.66823 36.3001H10.091C10.091 43.7709 16.1473 49.8272 23.6181 49.8272C31.089 49.8272 37.1453 43.7709 37.1453 36.3001H37.568C39.2022 36.3001 40.5271 34.9753 40.5271 33.3409C40.5271 31.7068 39.2022 30.3819 37.568 30.3819",
    stroke: "#2A2A2A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0084 13.9877C11.5039 16.1831 8.40002 20.8064 8.40002 26.1546V30.3819",
    stroke: "#2A2A2A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8362 30.3819V26.1546",
    stroke: "#2A2A2A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4727 53.209V45.3886",
    stroke: "#2A2A2A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7634 53.209V45.3886",
    stroke: "#2A2A2A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5271 15.1638H42.2179C45.0195 15.1638 47.2906 12.8927 47.2906 10.0911C47.2906 7.28952 45.0195 5.01836 42.2179 5.01836C41.6836 5.01836 41.1734 5.11064 40.6905 5.26494C39.9375 4.10142 38.6343 3.32749 37.1452 3.32749C36.5437 3.32749 35.9739 3.45711 35.4558 3.68366C34.4227 1.95503 32.5419 0.791184 30.3816 0.791184C27.1132 0.791184 24.4635 3.44076 24.4635 6.70933C24.4635 6.73823 24.4674 6.76618 24.4678 6.79497C24.1881 6.73795 23.9035 6.70926 23.618 6.70933C21.2835 6.70933 19.3909 8.60186 19.3909 10.9365C19.3909 13.2712 21.2835 15.1638 23.618 15.1638H26.1548",
    stroke: "#7A51AE",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5361 12.6275L28.6907 21.0819H32.0724L30.3815 30.3819L39.6814 18.5456H35.4543L37.9906 12.6275",
    stroke: "#7A51AE",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2021_5244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaregiver);
export default __webpack_public_path__ + "static/media/caregiver.7a8226a0af1e92fa8f007450e49f43ed.svg";
export { ForwardRef as ReactComponent };